// @flow
import React from 'react'
import Switch from 'react-switch'
import type {GridName} from '../entities'
import gridStore from 'stores/grid'
import {observer} from 'mobx-react'

type Props = {|
  gridName: GridName,
  static?: true
|}

export default observer(function GridMediaToggle (props:Props) {
  const innerStore = gridStore[props.gridName]
  return (
    <Switch
      onChange={props.static ? () => null : innerStore.toggleActive}
      checked={innerStore.active}
      id="normal-switch"
    />
  )
})


// WEBPACK FOOTER //
// ./src/config/GridMediaToggle.js